module.exports = __webpack_public_path__ + "static/media/RRD2-BG1.13809fba.jpg";